/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CreditcardpaymentresultSummary200,
  GetApiV1CreditcardpaymentresultSummary400,
  GetApiV1CreditcardpaymentresultSummary401,
  GetApiV1CreditcardpaymentresultSummary500,
  GetApiV1CreditcardpaymentresultSummaryQueryParams,
  GetApiV1CreditcardpaymentresultSummaryQueryResponse,
} from "../../types/creditCardPaymentResultController/GetApiV1CreditcardpaymentresultSummary.ts";
import { creditCardPaymentResultSummaryViewModelSchema } from "../creditCardPaymentResultSummaryViewModelSchema.ts";

export const getApiV1CreditcardpaymentresultSummaryQueryParamsSchema = z
  .object({
    StartDate: z.optional(z.string()),
    EndDate: z.optional(z.string()),
    CompanyId: z.optional(z.coerce.number().int()),
    ClassStudents: z.optional(z.string()),
    StudentName: z.optional(z.string()),
    Cpf: z.optional(z.string()),
    Approved: z.optional(z.coerce.number().int()),
    Merchant: z.optional(z.string()),
    Serial: z.optional(z.coerce.number().int()),
    TransactionCode: z.optional(z.string()),
    SortField: z.optional(z.string()),
    SortDirection: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1CreditcardpaymentresultSummaryQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CreditcardpaymentresultSummary200Schema = z.lazy(
  () => creditCardPaymentResultSummaryViewModelSchema,
) as unknown as ToZod<GetApiV1CreditcardpaymentresultSummary200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CreditcardpaymentresultSummary400Schema =
  z.any() as unknown as ToZod<GetApiV1CreditcardpaymentresultSummary400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CreditcardpaymentresultSummary401Schema =
  z.any() as unknown as ToZod<GetApiV1CreditcardpaymentresultSummary401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CreditcardpaymentresultSummary500Schema =
  z.any() as unknown as ToZod<GetApiV1CreditcardpaymentresultSummary500>;

export const getApiV1CreditcardpaymentresultSummaryQueryResponseSchema = z.lazy(
  () => getApiV1CreditcardpaymentresultSummary200Schema,
) as unknown as ToZod<GetApiV1CreditcardpaymentresultSummaryQueryResponse>;
